import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children, allowedLevels = [], allowedRoles = [] }) => {
  const token = localStorage.getItem('token');
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  try {
    const decodedToken = JSON.parse(atob(token.split('.')[1]));
    const userRole = decodedToken.role;
    const associationId = decodedToken.association_id;

    // For backward compatibility
    const effectiveAllowedRoles = allowedRoles.length > 0 ? allowedRoles : allowedLevels;

    // Committee roles that can have dual access
    const committeeRoles = [
      'admin',
      'uisp_territorial',
      'uisp_regional',
      'uisp_national',
      'uisp_territorial_secretary',
      'uisp_regional_secretary',
      'uisp_nazionale_secretary',
      'sda_territorial',
      'sda_regional',
      'sda_nazionale',
      'cordinator_territorial',
      'cordinator_regional',
      'cordinator_nazionale'
    ];

    const isCommitteeRole = committeeRoles.includes(userRole);
    const isDualRole = isCommitteeRole && associationId;

    // Define role-based dashboard paths
    const dashboardPaths = {
      admin: '/admin',
      uisp_national: '/admin',
      uisp_regional: '/admin',
      uisp_territorial: '/admin',
      uisp_territorial_secretary: '/admin',
      uisp_regional_secretary: '/admin',
      uisp_nazionale_secretary: '/admin',
      sda_territorial: '/admin',
      sda_regional: '/admin',
      sda_nazionale: '/admin',
      cordinator_territorial: '/admin',
      cordinator_regional: '/admin',
      cordinator_nazionale: '/admin',
      association: '/association'
    };

    // Check if user has permission to access this route
    if (effectiveAllowedRoles.length > 0) {
      const hasAccess = effectiveAllowedRoles.includes(userRole) || 
                        userRole === 'admin' ||
                        (effectiveAllowedRoles.includes('association') && isDualRole);
      
      if (!hasAccess) {
        // Redirect to unauthorized page instead of dashboard
        return <Navigate to="/unauthorized" replace state={{ from: location }} />;
      }
    }

    return children;
  } catch (error) {
    console.error('Token validation error:', error);
    localStorage.removeItem('token');
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
};

export default ProtectedRoute;